import { createContext } from 'react';
import { Map } from 'ol';

interface ViewerContextProps {
  map: Map | null;
}

const ViewerContext = createContext<ViewerContextProps>({ map: null });
export default ViewerContext;
